import { defineStore } from "pinia";
import {
  apiCheckVipPageInfo,
  apiGetDiscoveryNavigation,
  apiGetHomepageModuleList,
} from "@/api/vip";
import { isDev } from "@/config";
export const useVipStore = defineStore("vip", {
  state: () => ({
    userVip: {} as any,
    vipType: 0 as any, // 月度会员有1、8、9 周会员有7 无会员0
    vipTypeInfo: {} as any,
    vipNavObj: {} as any,
    vipNaviType: 7,
    vipFreeObj: {},
    vipGameObj: {},
    loadingPage: true,
    monthlyId: isDev ? 10196 : 31000, // 月会员id
    weeklyId: isDev ? 10195 : 21000, // 周会员id
  }),
  actions: {
    async fetchVipPageInfo() {
      const { userVip = {}, pageInfo } = await apiCheckVipPageInfo();
      console.log("获取页面数据成功:", { userVip, pageInfo });
      this.userVip = userVip || {};
      this.vipType = userVip?.vipType || 0;
      if ([1, 8, 9].includes(this.vipType)) {
        this.vipType = 1; //若是月会员都归为1
      }

      const vipTypeInfo = new Map<any, object>();
      pageInfo?.map((item: any) => {
        vipTypeInfo.set(item.vipType, item);
      });
      this.vipTypeInfo = vipTypeInfo;
    },

    async fetchVipModuleData() {
      if (Object.keys(this.vipNavObj).length) {
        console.log("避免模块列表重复获取");
        return;
      }
      const { list } = await apiGetDiscoveryNavigation({ homepageType: 1 });
      const vipNavObj = list?.find(
        (item: any) => item.type === this.vipNaviType
      );
      this.vipNavObj = vipNavObj;
      const moduleList = await apiGetHomepageModuleList({
        pageToken: "",
        discoveryId: vipNavObj?.id,
      });

      moduleList?.commonRes?.map((item: any) => {
        if (item.type === 46) {
          this.vipFreeObj = item;
        } else if (item.type === 48) {
          this.vipGameObj = item;
        }
      });
      // this.loadingPage = false;
      console.log("获取模块列表", moduleList);
    },

    async getPageData() {
      try {
        await Promise.all([this.fetchVipPageInfo(), this.fetchVipModuleData()]);
        // this.loadingPage = false;
      } catch (err) {
        console.log("获取页面数据失败:", err);
      }
    },

    async setLogin(isLogin: boolean) {
      if (!isLogin) {
        this.userVip = {};
        this.vipType = 0;
        // this.vipTypeInfo = {};
      }
      this.getPageData();
    },
    async clearVip() {
      this.userVip = {};
      this.vipType = 0;
    },
    setLoading() {
      this.loadingPage = true;
    },
    cancleLoading() {
      this.loadingPage = false;
    },
  },
});
